import PropTypes from 'prop-types';
import styles from './styles.module.scss';
import { size } from '@/helpers/lodash';
import Text from '@/components/component-library/Text';
import { classes } from '@/helpers/styling';

const ShowInfoGrid = ({ children }) => !!size((children || []).filter(_ => _)) && (
  <div className={ styles.showInfoGrid }>
    { children }
  </div>
);

ShowInfoGrid.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]).isRequired
};

export const ShowInfoGridRow = ({
  title,
  textValue,
  renderedValue,
  shouldDisplay,
  isLoading
}) => {
  if (!shouldDisplay || !((textValue || '').toString().trim() || renderedValue)) {
    return null;
  }

  return (
    <>
      <Text
        bold className={ styles.showInfoGridRowTitle } loading={ isLoading }
        useHeaderFont
      >
        { title }
      </Text>
      { textValue ? (
        <Text
          bold className={ classes(styles.textValue, { [styles.isLoading]: isLoading }) } loading={ isLoading }
          useHeaderFont
        >
          { textValue }
        </Text>
      ) : renderedValue }
    </>
  );
};

ShowInfoGridRow.propTypes = {
  title: PropTypes.string.isRequired,
  textValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  renderedValue: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]),
  shouldDisplay: PropTypes.bool,
  isLoading: PropTypes.bool
};

ShowInfoGridRow.defaultProps = {
  textValue: '',
  renderedValue: null,
  shouldDisplay: true,
  isLoading: false
};

export default ShowInfoGrid;